// src/routes/SharedRoutes.js
import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { Helmet } from '@dr.pogodin/react-helmet';
import ProtectedRoute from '../components/auth/ProtectedRoute';
import PublicLayout from '../components/layout/PublicLayout';

// Shared Pages
import Notifications from '../pages/shared/Notifications';
import Help from '../pages/shared/Help';
import Support from '../pages/shared/Support';
import PrivacyPolicy from '../pages/shared/PrivacyPolicy';

const SharedRoutes = () => {
  return (
    <Routes>
      <Route element={<PublicLayout />}>
       <Route 
        path="notifications" 
        element={
          <ProtectedRoute>
            <Helmet>
              <title>Notifications - MediGo</title>
              <meta name="robots" content="noindex, nofollow" />
            </Helmet>
            <Notifications />
          </ProtectedRoute>
        } 
      />
        <Route 
          path="help" 
          element={
            <>
              <Helmet>
                <title>Help Center - MediGo Support</title>
                <meta name="description" content="Get help and find answers to frequently asked questions about MediGo services." />
              </Helmet>
              <Help />
            </>
          } 
        />
        
        <Route 
          path="support" 
          element={
            <>
              <Helmet>
                <title>Support - MediGo Customer Service</title>
                <meta name="description" content="Contact MediGo support team for technical assistance and customer service." />
              </Helmet>
              <Support />
            </>
          } 
        />
        
        <Route 
          path="privacy-policy" 
          element={
            <>
              <Helmet>
                <title>Privacy Policy - MediGo</title>
                <meta name="description" content="Read MediGo's privacy policy and data protection practices." />
              </Helmet>
              <PrivacyPolicy />
            </>
          } 
        />
      </Route>
    </Routes>
  );
};

export default SharedRoutes;